import React from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
  height: 100%;
  overflow: hidden;
`;

const InnerContainer = styled.div`
  padding-top: 5px;
`;

const ResizablePageContent = ({ children, }: any,) => (
  <Container>
    <InnerContainer>
      {children}
    </InnerContainer>
  </Container>
);

export default ResizablePageContent;
